import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output } from '@angular/core'
import { AuthService, ChatService, ModalService, RestServices, SharedServices } from '@app/services'
import { APP_CONFIG, Config, ConfigService } from '@services/config.service'
import { ChatModel } from '@models/chat.model'
import { ClientModel } from '@models/client.model'
import { ArrayHelper } from '@helpers/array.helper'
import MainConfig from '../../../../../config/main'
import { Router } from '@angular/router'


@Component({
    selector: 'app-chat-detail-modal',
    templateUrl: './chat-detail-modal.component.html',
    styleUrls: [
        '../../../../stagingcss/root-ui-view.component.css',
        '../../../../stagingcss/ui-schema-table-form.component.css',
        './chat-detail-modal.component.css',
        '../../../../stagingcss/image-viewer.component.css',
        '../../../../stagingcss/radial-progress.component.css'],
})
export class ChatDetailModalComponent implements OnInit {

    @Input() showPatient = false

    en = {}
    showEN = true
    active = false
    chatTags = []
    chatPrivateTags = []
    selectedCommunicationTags = []
    selectedChatTags = []
    chatModel: ChatModel
    doctorInChargeDeleted
    staffInChargeDeleted
    communicationId = ''
    type = ''
    enablePrivateTag: boolean
    config: Config
    client: ClientModel
    communicationchatId = ''
    familyName
    firstName
    @Output() _closeAndScrollToTarget: EventEmitter<any> = new EventEmitter()

    constructor(private authService: AuthService,
                private restApi: RestServices,
                public configService: ConfigService,
                private modalService: ModalService,
                private sharedService: SharedServices,
                public chatService: ChatService,
                private router: Router,
                @Inject(APP_CONFIG) config: Config) {

        this.config = config
        this.enablePrivateTag = MainConfig.ENABLE_CHAT_PRIVATE_TAG
        modalService.changeEmitted$.subscribe(success => {
            if (success) {
                if (success[0] === 'showModalChatDetail') {
                    this.clear()
                    if (success[2]) {
                        this.showPatient = success[2]
                    }

                    if (success[3]) {
                        this.scrollToElement(success[3])
                    }

                    if (success[4]) {
                        this.communicationchatId = success[4]
                        this.familyName = success[5]
                        this.firstName = success[6]
                    } else {
                        this.communicationchatId = ''
                    }
                    this.openModal(success[1])
                }
            }
        })
        chatService.closeChat$.subscribe(chatModel => {
            this.active = false
        })

        sharedService.changeEmitted$.subscribe(res => {
            if (res == 'closeModalPdf') {
                this.hideModal()
            }
        })
    }

    ngOnInit() {
        if (this.config) {
            this.chatTags = this.config.chatTags
            this.chatPrivateTags = this.config.chatPrivateTags
        }
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            this.hideModal()
        }
    }

    scrollToElement(elementId) {
        if (!elementId) {
            return
        }
        setTimeout(() => {
            if (document.getElementById(elementId)) {
                document.getElementById(elementId).scrollIntoView()
            } else {
                console.warn('element not found', elementId)
            }
        }, 500)
    }

    openModal(chatId) {
        this.communicationId = chatId

        this.chatService.getChatInfo(chatId, this.showPatient).subscribe((chatData: ChatModel) => {
            if (chatData) {
                const resourceData = {
                    actions: [],
                    status: {
                        clinic: {
                            paths: {
                                '{}': true,
                            },
                        },
                        setting: {
                            map: {
                                common: true,
                            },
                            paths: {
                                '{}': true,
                            },
                        },
                        staff: {
                            paths: {
                                '{"roles":"cordinator"}': true,
                                '{"roles":"doctor"}': true,
                                '{}': true,
                            },
                        }
                    },
                }
                this.authService.authToken().then(tokenReNew => {
                    this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                        if (success) {
                            this.active = true
                            this.chatModel = chatData
                            this.selectedCommunicationTags = chatData.tags || []
                            this.selectedChatTags = chatData.privateTags || []
                            this.type = chatData.type
                            this.chatModel.doctorInCharge = this.configService.getStaffName(chatData.doctor)
                            this.doctorInChargeDeleted = this.configService.getStaff(chatData.doctor).deleted
                            const staff = success['response']['staff']['paths']['{}'].find(el => {
                                return el['_id'] == chatData.staff
                            })
                            this.chatModel.staffInCharge = this.configService.getStaffName(chatData.staff)
                            this.staffInChargeDeleted = staff.deleted
                        }
                    })
                })

                
                if (this.showPatient) {
                    this.client = chatData.client
                }
            }
        })
    }

    hideModal() {
        this.active = false
        this.clear()
        this.chatService.close()
    }

    changeLanguage() {
        return this.en = this.authService.showLang(this.showEN)
    }

    initCommunicationTags(tags = []) {
        return this.chatTags.filter(i => tags.includes(i._id))
    }

    checkChatTag(item) {
        if (this.selectedChatTags.length > 0) {
            return this.selectedChatTags.findIndex((e) => {
                return e === item._id
            }) !== -1
        }
        return false
    }

    private clear() {
        this.communicationId = ''
        this.showPatient = false
        this.selectedChatTags = []
        this.selectedCommunicationTags = []
        this.chatModel = null
        this.client = null
        this.staffInChargeDeleted = undefined
        this.doctorInChargeDeleted = undefined
    }

    togglePrivateTag(item: any) {
        this.selectedChatTags = ArrayHelper.toggleSelectedItem(this.selectedChatTags, item)
        this.chatService.updateChatPrivateTag(this.selectedChatTags)
    }

    get getQuoteContent() {
        if (this.chatModel && this.chatModel.communication) {
            if (this.chatModel.communication.note || this.chatModel.communication.content) {
                return this.chatModel.communication.note || this.chatModel.communication.content
            } else {
                switch (this.chatModel.communication.type) {
                    case 'image':
                        return 'Image'
                    case 'pdf':
                        return 'PDF'
                    case 'video':
                        return 'Video'
                }
            }
        }
    }

    closeAndScrollToTarget(value) {
        this.hideModal()
        if (this.communicationchatId) {
            this.router.navigateByUrl('/app/main/client/edit/' + value.clientId + '/communication')
            setTimeout(() => {
                this.scrollIntoViewRootChat('chat_' + value.communicationId)
            }, 10)
        }
        if (value.communicationId) {
            // this.clean();
            setTimeout(() => {
                this.scrollIntoViewRootChat('chat_' + value.communicationId)
            }, 10)
        }
        this.communicationchatId = ''

    }

    scrollIntoViewRootChat(id) {
        if (id != null) {
            setTimeout(() => {
                document.getElementById(id).scrollIntoView()
            }, 50)
        }
        this.communicationchatId = ''
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/modal-commons/chat-detail-modal/chat-detail-modal.component.ts